module.exports = __webpack_public_path__ + "static/yeth_hound-ec95c377252f0ece907cac0c28b10113.jpeg";